import BaseFooter from './BaseFooter.vue';
import FooterLink from './FooterLink.vue';

export { BaseFooter, FooterLink };
